/**
 * BP Tickets — mirrors the Airtable "BP Tickets" table (base app8EGOrjo9VBouLx) via
 * proxy-server/lib/bpTickets.js. See services/bpTicketsApi.ts.
 */
export type TicketCategory =
  | 'Contract Amendment'
  | 'Leave Management'
  | 'Policy Question'
  | 'Workation Request'
  | 'Visa Request'
  | 'Onboarding Request'
  | 'Offboarding Request'
  | 'Other';

// Mirrors the CATEGORIES list validated server-side in proxy-server/lib/bpTickets.js — keep both
// in sync.
export const TICKET_CATEGORIES: TicketCategory[] = [
  'Contract Amendment',
  'Leave Management',
  'Policy Question',
  'Workation Request',
  'Visa Request',
  'Onboarding Request',
  'Offboarding Request',
  'Other',
];

export type TicketDepartment = 'Finance & Legal' | 'Fleet' | 'Growth' | 'Operations' | 'People' | 'Tech';

export type TicketPriority = 'Regular' | 'Urgent';

export const TICKET_PRIORITIES: TicketPriority[] = ['Regular', 'Urgent'];

export type TicketStatus = 'Submitted' | 'In Progress' | 'Waiting for Employee' | 'Resolved' | 'Cancelled';

export const TICKET_STATUSES: TicketStatus[] = [
  'Submitted',
  'In Progress',
  'Waiting for Employee',
  'Resolved',
  'Cancelled',
];

export interface TicketDri {
  email: string;
  name: string;
}

export interface BpTicket {
  id: string;
  ticketNumber: number | null;
  summary: string;
  category: TicketCategory | null;
  details: string;
  submittedBy: string;
  department: TicketDepartment | null;
  priority: TicketPriority;
  status: TicketStatus;
  dri: TicketDri | null;
  createdAt: string | null;
  lastChangedAt: string | null;
  statusLastChangedAt: string | null;
  slackSource: string | null;
  autoCreated: boolean;
}
